export default {
  general: {
    actions: {
      back: 'Zurück',
      continue: 'Weiter',
      order: 'Bestellen'
    },
    month: 'Monat',
    instead: 'statt {currency} {oldprice}',
    charge: 'zzgl. einmaliger Gebühr von {charge}'
  },
  pages: {
    email: {
      title: 'Bitte gib deine E-Mail-Adresse ein',
      email: 'E-Mail-Adresse',
      error: 'Bitte gib eine gültige E-Mail-Adresse ein.'
    },
    start: {
      description: 'Damit wir nachher gleich loslegen können, benötigst du einen Website Creator Account. <br>Diesen kannst du 30 Tage kostenlos testen und jederzeit kündigen.'
    },
    userdata: {
      title: 'Kundendaten',
      description: 'Gib deinen Namen und Kontaktinformationen ein',
      salutation: 'Anrede',
      salutations: {
        Frau: 'Frau',
        Herr: 'Herr'
      },
      firstname: 'Vorname',
      lastname: 'Name',
      street: 'Strasse, Nr.',
      zip_code: 'PLZ',
      city: 'Ort',
      country: 'Land',
      phone: 'Telefon',
      gtc: 'Allgemeinen Geschäftsbedingungen (AGB)',
      privacy: 'Datenschutzbestimmungen',
      agreement: 'Ich bestätige hiermit, dass ich die {gtc} und die {privacy} von hosttech gelesen, verstanden und akzeptiert habe. Bitte beachten Sie zudem, dass Ihre E-Mail Adresse als Kontakt- und Rechnungsadresse verwendet wird.',
      error: 'Das Formular wurde nicht korrekt ausgefüllt.'
    },
    verify_email: {
      title: 'Gib deinen Supportcode ein',
      description: 'Diese E-Mail-Adresse existiert bereits. Bitte gib deinen Supportcode ein. Diesen findest Du im myhosttech Kundencenter. Sofern du Hilfe benötigst, hilft dir die Kursleitung gerne weiter.',
      error: 'Der Supportcode stimmt nicht mit deinem Account überein.',
      supportcode: 'Supportcode'
    },
    domain: {
      title: 'Domain',
      description: 'Gib deine Wunschdomain für die Website an. Falls Du diese noch nicht kennst, gib einen Phantasienamen ein (inkl. Domainendung. Hinweis: Die Domain wird nicht registriert, sondern nur installiert. Falls Du die Domain registrieren möchtest, sprich bitte die Kursleitung an.',
      domain: 'Domain',
      error: 'Bitte gib eine gültige Domain ein.'
    },
    createaccount: {
      title: 'Bitte einen Moment Geduld',
      description: 'Dein Account wird bereitgestellt.',
      error: 'Es ist ein Fehler aufgetreten. Bitte starte den Vorgang neu.'
    },
    success: {
      title: 'Wir wünschen dir einen erfolgreichen Kurs!',
      description: 'Account erstellt!',
      login: 'Jetzt einloggen!',
      confirmation: 'Deine Zugangsdaten haben wir an {email} geschickt.'
    }
  },
  components: {
    common: {
      pageHeader: {
        steps: 'Schritt {step} von {totalSteps}'
      }
    },
    start: {
      product: {
        subtitle: 'inkl. Webhosting'
      }
    }
  }
}
